var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"stream",attrs:{"justify-center":"","align-center":"","fill-height":""}},[_c('img',{staticClass:"train__img",attrs:{"src":`http://${_vm.location.host}/rtsp/${_vm.options.name}`,"alt":""}}),_c('canvas',{staticStyle:{"position":"absolute","cursor":"crosshair"},attrs:{"height":"720","width":"1280"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }